import React, { lazy } from 'react';
import { CreateRoot } from '../../assets/js/react';
const VaccineBooking = lazy(() => import("../../assets/js/react/components/vaccine-booking/vaccine-booking"));

CreateRoot('vaccine-booking', <VaccineBooking />);
